import {
  getProgressMeterFillColor,
  ProgressMeter,
  type ProgressMeterInk,
} from "@-/dev.improve.haniverse.components.ui.progress-meter";
import type { ReactNode } from "react";

/** The layer an ink copy sits over: black reads on every fill color, theme ink on the track. */
export type LearnReviewRechargeInk = ProgressMeterInk;

/**
 * The review recharge bar's meter: the app's flat `ProgressMeter`, golden while charging and
 * orange while the charge is being spent (`getProgressMeterFillColor`).
 */
export function LearnReviewRechargeMeter({
  children,
  fraction,
  isFaded = false,
  isSpending = false,
  vertical = false,
}: {
  children?: (ink: LearnReviewRechargeInk) => ReactNode;
  fraction: number;
  isFaded?: boolean;
  isSpending?: boolean;
  vertical?: boolean;
}) {
  return (
    <ProgressMeter
      fillColor={getProgressMeterFillColor({ fraction, isSpending })}
      fillTestID="learn-review-recharge-fill"
      fraction={fraction}
      isFaded={isFaded}
      testID="learn-review-recharge-meter"
      vertical={vertical}
    >
      {children}
    </ProgressMeter>
  );
}
